<div class="developer">
    <div>
        <priva-title title="Developer menu" />
    </div>
    <table class="developer__table">
        <tr>
            <td>
                <button priva-button (click)="toggleLanguage()">Toggle Language</button>
            </td>
            <td>Toggle language between EN and NL</td>
        </tr>
        <tr>
            <td>
                <button priva-button (click)="clearMasterData()">Clear masterData</button>
            </td>
            <td>Remove master data</td>
        </tr>
        <tr>
            <td>
                <button priva-button (click)="clearPreferences()">Clear preferences</button>
            </td>
            <td>Remove preferences</td>
        </tr>
        <tr>
            <td>
                <button priva-button (click)="clearAll()">Clear all</button>
            </td>
            <td>Remove all data. Setup needs to be run again</td>
        </tr>

        <tr>
            <td>
                <button priva-button (click)="clearRegistrations()">Clear registrations</button>
            </td>
            <td>Clears the registration cache</td>
        </tr>
        <tr>
            <td>
                <button priva-button (click)="mockServerLogin()">Mock server login</button>
            </td>
            <td>Mock server login</td>
        </tr>
        <tr>
            <td>
                <button priva-button (click)="logout()">Logout</button>
            </td>
            <td>Logout</td>
        </tr>
    </table>

    <div class="developer__cached-registrations">
        <div>
            <priva-title theme="onwhite" title="Cached registrations" />
        </div>
        <div class="cached-registrations-table">
            <app-registrations-table />
        </div>
    </div>
</div>
